const ButtonVariant = {
  Default: '_default',
  DefaultBorder: 'defaultBorder',
  IconBase: 'iconBase',
  Icon: 'icon',
  IconCentered: 'iconCentered',
  IconText: 'iconText',
  NoBackground: 'noBackground',
  Login: 'login',
  Submit: 'submit',
  Cancel: 'cancel',
  Popup: 'popup',
  PopupContext: 'popupContext',
  Header: 'header',
  HeaderLogo: 'headerLogo',
};

export default ButtonVariant;
